<template>
  <div class="dialog_sueecss_pc">
    <div class="sueecss_box">
      <div class="dialog-close">
        <i class="el-icon-close" @click="() => this.$emit('closeform')"></i>
      </div>
      <img :src="retainImg" alt="" />
    </div>
  </div>
</template>

<script>
import http from '../../../../../packages/ukey/utils/http'
export default {
  data() {
    return {
      retainImg: '',
    }
  },
  mounted() {
    http({
      url: `${process.env.VUE_APP_WEB_URL}v1/saas-common/banners/portal_esign/home/list`,
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    }).then(resData => {
      const { bannerList } = (resData && resData.data) || {}
      const bannerId =
        bannerList &&
        bannerList.map(item => {
          return item.bannerId
        })
      const bannerIdNum = Number(process.env.VUE_APP_LUODI_LIUZI)
      const index = bannerId && bannerId.indexOf(bannerIdNum)
      this.retainImg =
        resData && resData.data && resData.data.bannerList && resData.data.bannerList[index] && resData.data.bannerList[index].picUrl
    })
  },
}
</script>

<style lang="less" scoped>
.dialog_sueecss_pc {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10000;
  background-color: rgba(0, 0, 0, 0.45);
}
.dialog-close {
  width: 100px;
  height: 100px;
  background: url('../../../../assets/images/trial_dialog_close_bg.png') top right / cover no-repeat;
  position: absolute;
  top: 0;
  right: 0;
}

.sueecss_box {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 460px;
  height: 500px;
  padding: 0 50px;
  font-size: 14px;
  box-shadow: 6px 6px 13px 10px rgba(2, 6, 11, 0.23);
  background: #fff;
  color: #666b80;
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
  i {
    position: absolute;
    top: 12px;
    right: 14px;
    font-size: 24px;
    cursor: pointer;
  }
  img {
    padding-top: 100px;
    height: 460px;
  }
}
</style>
